import axios from 'axios'
import { getUser } from './auth'

const BASE_URL = process.env.NODE_ENV === 'production' ? 'https://api-apollo.tianenusa.com' : 'http://localhost:8080'

export {
  getFactoriesOverview,
  getFactory,
  saveFactory,
  getArticlesOverview,
  getArticle,
  saveArticle,
  searchArticle,
  createReport,
  uploadPdfSplit
}

function getRestOptions(token) {
  return {
    headers: {
      'Accept': 'application/json',
      'Authorization': `Bearer ${token}`
    }
  }
}

function getFactoriesOverview() {
  const url = `${BASE_URL}/factoriesOverview`
  const token = JSON.parse(getUser()).token
  const options = getRestOptions(token)
  return axios.get(url, options).then(response => response.data)
}

function getFactory(factoryCode) {
  const url = `${BASE_URL}/factories/${factoryCode}`
  const token = JSON.parse(getUser()).token
  const options = getRestOptions(token)
  return axios.get(url, options).then(response => response.data)
}

function saveFactory(factory, existing) {
  let url = `${BASE_URL}/factories`
  if (existing !== undefined && existing === true) {
    url = `${url}/${factory.factoryCode}`
  }
  const token = JSON.parse(getUser()).token
  const options = getRestOptions(token)
  return axios.post(url, factory, options)
}

function getArticlesOverview() {
  const url = `${BASE_URL}/articlesOverview`
  const token = JSON.parse(getUser()).token
  const options = getRestOptions(token)
  return axios.get(url, options).then(response => response.data)
}

function getArticle(articleId) {
  const url = `${BASE_URL}/articles/${articleId}`
  const token = JSON.parse(getUser()).token
  const options = getRestOptions(token)
  return axios.get(url, options).then(response => response.data)
}

function saveArticle(article, existing) {
  let url = `${BASE_URL}/articles`
  if (existing !== undefined && existing === true) {
    url = `${url}/${article.articleId}`
  }
  const token = JSON.parse(getUser()).token
  const options = getRestOptions(token)
  return axios.post(url, article, options)
}

function searchArticle(param) {
  const url = `${BASE_URL}/articlesSearch`
  const token = JSON.parse(getUser()).token
  const options = getRestOptions(token)
  return axios.post(url, param, options)
}

function uploadPdfSplit(form) {
  const url = `${BASE_URL}/pdf/split`
  const token = JSON.parse(getUser()).token
  return axios.post(
    url,
    form,
    {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'multipart/form-data'
      },
      responseType: 'blob'
    })
}

function createReport(report) {
  const url = `${BASE_URL}/reports`
  const token = JSON.parse(getUser()).token
  return axios.post(
    url,
    report,
    {
      headers: {
        'Authorization': `Bearer ${token}`
      },
      responseType: 'blob'
    }
  )
}



// WEBPACK FOOTER //
// ./src/utils/api.js